/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable */
import AgreementApi from '@/api/agreement';
import ContractApi from '@/api/contract';
import { ContractData } from '@/api/contract/types';
import { getLegalConstract } from '@/api/legal-constact';
import { LegalConstract } from '@/api/legal-constact/type';
import { getContractsInfo } from '@/ContractConfig';
import { ContractEnum } from '@/enums/contract-type';
import { ZHONGYOU_COMMODITY } from '@/shared/commodity';
import { isUseGeneralAgreesApi } from '@/constant';
import { Component, Vue } from 'vue-property-decorator';
import { isNeedTakeLocalFiles } from './localfiles';

@Component
export default class LegalAgreementsMixins extends Vue {

  protected async getLegalAgreements(): Promise<LegalConstract> {
    const legalConstract = await (
      isUseGeneralAgreesApi()
        ? AgreementApi.generalQueryUserAgreeRecords() as unknown as LegalConstract
        : getLegalConstract()
    );

    return legalConstract;
  }

  // 获取授信协议
  protected async creditAgreement(commodityId: number, sourcePage?: string): Promise<ContractData[]> {
    const parms = {
      commodityId,
      sourcePage,
      type: commodityId+ '' === ZHONGYOU_COMMODITY ? ContractEnum.ZY_PREAPPLY :ContractEnum.PREAPPLY,
    };
    let creditAgreement: ContractData[] = Object.create(null);
    if (isNeedTakeLocalFiles(String(commodityId))) {
      // 本地协议获取
      creditAgreement = getContractsInfo(commodityId, parms.type).items as ContractData[];
    } else {
      // 线上接口URL获取
      creditAgreement = await ContractApi.getDynamicUrl(parms);
    }

    return creditAgreement;
  }
}
